<div class="relative inline-flex items-center gap-2" #trigger (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
  <label *ngIf="label" class="text-[11px] font-bold text-gray-800 uppercase tracking-wide whitespace-nowrap">{{label}}</label>

  <div (click)="$event.stopPropagation(); toggle()"
    class="border-[1.5px] rounded-lg font-medium cursor-pointer transition-colors"
    [ngClass]="[open ? 'border-[var(--primary-dark)] text-gray-800' : 'border-gray-300 text-gray-800', compact ? 'py-1 px-2 text-[10px] min-w-[80px]' : 'py-1.5 px-2.5 text-[11px] min-w-[100px]']">
    {{displayValue}}
  </div>

  <!-- Popup -->
  <div *ngIf="open"
    class="fixed bg-white rounded-xl shadow-[0_8px_40px_rgba(0,0,0,0.12)] p-3 w-[240px]"
    [ngStyle]="popupStyle"
    style="z-index: 99999;"
    (click)="$event.stopPropagation()">

    <!-- Days view -->
    <ng-container *ngIf="view === 'days'">
      <div class="flex items-center justify-between mb-2">
        <span class="material-icons text-[16px] text-gray-400 cursor-pointer hover:text-[var(--primary-dark)]" (click)="prevMonth(); $event.stopPropagation()">chevron_left</span>
        <span class="text-[11px] font-bold text-[var(--primary-dark)] cursor-pointer hover:underline" (click)="showMonths(); $event.stopPropagation()">{{monthLabel}}</span>
        <span class="material-icons text-[16px] text-gray-400 cursor-pointer hover:text-[var(--primary-dark)]" (click)="nextMonth(); $event.stopPropagation()">chevron_right</span>
      </div>
      <div class="grid grid-cols-7 mb-1">
        <span *ngFor="let d of ['Su','Mo','Tu','We','Th','Fr','Sa']" class="text-[9px] font-semibold text-gray-500 text-center">{{d}}</span>
      </div>
      <div class="grid grid-cols-7">
        <div *ngFor="let day of days"
          class="flex items-center justify-center cursor-pointer rounded-md transition-colors mx-auto"
          [ngClass]="[compact ? 'w-7 h-7 text-[10px]' : 'w-8 h-8 text-[11px]', isSelected(day) ? 'bg-[var(--primary-dark)] text-white font-bold' : (day ? 'hover:bg-gray-100 text-gray-700' : '')]"
          (click)="day && selectDay(day); $event.stopPropagation()">
          {{day || ''}}
        </div>
      </div>
      <div *ngIf="!compact" class="flex items-center justify-between mt-2 pt-2 border-t border-gray-100">
        <span class="text-[10px] font-medium text-gray-500 cursor-pointer hover:text-gray-900" (click)="clear(); $event.stopPropagation()">Clear</span>
        <span class="text-[10px] font-medium text-[var(--primary-dark)] cursor-pointer hover:opacity-80" (click)="today(); $event.stopPropagation()">Today</span>
      </div>
    </ng-container>

    <!-- Months view -->
    <ng-container *ngIf="view === 'months'">
      <div class="flex items-center justify-between mb-2">
        <span class="text-[11px] font-bold text-[var(--primary-dark)] cursor-pointer hover:underline" (click)="showYears(); $event.stopPropagation()">{{viewDate.getFullYear()}}</span>
      </div>
      <div class="grid grid-cols-3 gap-1">
        <div *ngFor="let m of months; let i = index"
          class="py-2 text-center text-[10px] font-medium rounded-lg cursor-pointer transition-colors"
          [ngClass]="viewDate.getMonth() === i ? 'bg-[var(--primary-dark)] text-white' : 'hover:bg-gray-100 text-gray-700'"
          (click)="selectMonth(i); $event.stopPropagation()">
          {{m}}
        </div>
      </div>
    </ng-container>

    <!-- Years view -->
    <ng-container *ngIf="view === 'years'">
      <div class="flex items-center justify-between mb-2">
        <span class="material-icons text-[16px] text-gray-400 cursor-pointer hover:text-[var(--primary-dark)]" (click)="prevYearRange(); $event.stopPropagation()">chevron_left</span>
        <span class="text-[11px] font-bold text-gray-600">{{yearRange[0]}} – {{yearRange[yearRange.length - 1]}}</span>
        <span class="material-icons text-[16px] text-gray-400 cursor-pointer hover:text-[var(--primary-dark)]" (click)="nextYearRange(); $event.stopPropagation()">chevron_right</span>
      </div>
      <div class="grid grid-cols-3 gap-1">
        <div *ngFor="let y of yearRange"
          class="py-2 text-center text-[10px] font-medium rounded-lg cursor-pointer transition-colors"
          [ngClass]="viewDate.getFullYear() === y ? 'bg-[var(--primary-dark)] text-white' : 'hover:bg-gray-100 text-gray-700'"
          (click)="selectYear(y); $event.stopPropagation()">
          {{y}}
        </div>
      </div>
    </ng-container>
  </div>
</div>
